/* eslint-disable no-unused-vars */
import React from "react";
import UploadCSV from "../../components/UploadCSV";

function AdminSettings() {


  return (
    <div className="">
      <h2 className="text-2xl font-medium">Profile Settings</h2>
      <div>
        <div className=" p-4">
        <p className="text-xl font-bold">Upload Parameters</p>
        <UploadCSV endpoint="/api/admin/csvToJson/parameters" /></div>
      <div className=" p-4">
        <p className="text-xl font-bold">Upload Rationale</p>
        <UploadCSV endpoint="/api/admin/csvToJson/rationale" /></div>
      </div>
    </div>
  );
}

export default AdminSettings;
